/* Nifty nuget that gets a key-value pair of method arguments */
const STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
const ARGUMENT_NAMES = /([^\s,]+)/g;
Function.prototype.keyParams = function( args ){
    var fnStr = this.toString().replace(STRIP_COMMENTS, '');
    var result = fnStr.slice(fnStr.indexOf('(')+1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
    if(result === null)
        result = {};


    var resultingObject = {};
    for( var i = 0; i < result.length; i++ ){
        resultingObject[result[i]] = args[i];
    }
    return resultingObject;
}

Function.prototype.mapParams = function( obj, args ){
    Object.assign( obj, this.keyParams( args ) );
};
